import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from "@angular/core";
import { HttpService } from "../core/services/http.service";
import { FormBuilder, FormGroup, Validators, ValidatorFn, ValidationErrors } from "@angular/forms";
import { ToastrTranslateService } from "../core/services/toastr-translate.service";
import { Observable, Subscription } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-reset-password-myaccount",
  templateUrl: "./reset-password-myaccount.component.html",
  styleUrls: ["./reset-password-myaccount.component.scss"],
})
export class ResetPasswordMyaccountComponent implements OnInit, OnDestroy {
  @Output() closeModalEvent = new EventEmitter<boolean>();
  resetPasswordForm: FormGroup;
  loggedInUserData: any;
  subscription: Subscription;
  constructor(private httpService: HttpService, private formBuilder: FormBuilder, private toastr: ToastrTranslateService, private router: Router) {}

  ngOnInit() {
    this.httpService.callApi("loggedInUser", {}).subscribe(
      (response) => {
        this.loggedInUserData = response;
      },
      (error) => {
        this.toastr.warning("Unable to load user data", "Reset Password");
      }
    );
    this.resetPasswordForm = this.createFormGroup();
    this.subscription = this.password.valueChanges.subscribe((password) => {
      this.confirmPassword.reset();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription != undefined && this.subscription.unsubscribe() != undefined) {
      this.subscription.unsubscribe();
    }
  }

  closeModal() {
    this.closeModalEvent.emit(false);
  }

  changePassword() {
    if (this.resetPasswordForm.invalid) {
      return;
    }
    if (!confirm("You will be logged out. Are you sure?")) {
      return;
    }
    let body = JSON.parse(JSON.stringify(this.loggedInUserData));
    body.contractSettingDTO = null;
    body.userSettingDTO.existingPassword = this.existingPassword.value;
    body.userSettingDTO.password = this.password.value;
    body.userSettingDTO.confirmPassword = this.confirmPassword.value;
    this.httpService.callApi("changePassword", { body: body }).subscribe(
      (response) => {
        this.loggedInUserData = response;
        this.toastr.success("Your Password for Teamium has been reset.");
        localStorage.clear();
        localStorage.clear();
        this.router.navigate(["/signin"]).then(() => {
          console.log("reload called");
          document.location.reload();
        });
      },
      (error) => {
        //  this.toastr.warning('Old password does not match');
        this.toastr.warning(error.error.message === "Incorrect Password" ? "Old password does not match" : error.error.message, "Reset Password");
        //  this.router.navigate(['user-dashboard/agenda']);
      }
    );
  }

  createFormGroup(): FormGroup {
    return this.formBuilder.group(
      {
        existingPassword: [null, Validators.compose([Validators.required])],
        password: [null, Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(20)])],
        confirmPassword: [null, Validators.compose([Validators.required])],
      },
      { validator: this.passwordMatcher }
    );
  }
  get password() {
    return this.resetPasswordForm.get("password");
  }
  get confirmPassword() {
    return this.resetPasswordForm.get("confirmPassword");
  }
  get existingPassword() {
    return this.resetPasswordForm.get("existingPassword");
  }

  passwordMatcher: ValidatorFn = (formGroup: FormGroup): ValidationErrors | null => {
    let password = formGroup.get("password");
    let confirmPassword = formGroup.get("confirmPassword");
    return password && confirmPassword && password.value !== confirmPassword.value ? { passwordMatch: true } : null;
  };
}
